import { IParamsActionLog, IResponseActionLogs } from '~/utils/interface/actionLog';
import axiosClient from './axiosClient';

const url: string = '/api/action-logs';

const actionLogApi = {
  getActionLogs(params: IParamsActionLog) {
    return axiosClient.get<IResponseActionLogs>(url, { params });
  },
};
export default actionLogApi;
